<!-- footer -->
<template>
  <div id='footerPage'>
    <div class="footer-top">
      <div class="footer-top-content">
        <p class="title">{{topTitle}}</p>
        <button class="cooperBtn" @click="$router.push('/application')">申请合作</button>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <div class="footer-bottom-nav">
          <div class="nav">
            <div class="nav-item" v-for="(item, index) in navList" :key="index">
              <div class="nav-name" v-if="item.children&&item.children.length > 0">
                <div class="sub-nav" @click="toggleNav(item.type)">{{item.name}}
                    <img class="sub-nav-img" :class="{isRotate: currentType===item.type}" src="https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/avatar/icon-arrow-m.png">
                </div>
                <div class="sub-box" v-if="currentType===item.type">
                    <div class="sub-nav-item" v-for="(temp, index) in item.children" :key=index @click="goPath(temp.path)">{{temp.name}}</div>
                </div>
              </div>
              <div class="nav-name" v-else @click="goPath(item.path)">
                  <div class="sub-nav">{{item.name}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom-content-item">
          <div class="introduce-box">
            <div class="info-li" v-for="(item, index) in footerText" :key="index">
              <span class="title" v-html="item.title">{{item.title}}</span>
              <a href="tel:400 006 3390" v-if="item.isTel" class="tel">{{item.tel}}</a>
              <span class="content">{{item.content}}</span>
            </div>
          </div>
          <div class="qrcode-box">
              <img class="qrcodeImg" src='../../assets/images/logo/ms-qrcode.png' />
            </div>
        </div>
        <div class="copy-box">
            <div class="line"></div>
            <p class="copyright">Copyright © ️2020  好未来版权所有  北京学而思教育科技有限公司  <span @click="goBeian">京ICP备09032638号-16</span></p>
            <p class="backup" @click="goDetial">京公网安备 11010802022239号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { navList } from '@/const'
export default {
  props: {
    toTop: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      navList: navList,
      noTopRouter: '/application',
      topTitle: '成就每一个教育理想',
      footerText: [
        { title: '咨询电话:', content: ' 转 8009', isTel: true, tel: '400 006 3390' },
        { title: '邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱:', content: 'ms.hezuo@100tal.com' },
        { title: '地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址:', content: '北京市海淀区中关村11号E世界A座5层' }
      ],
      footerBottom: ['Copyright © ️2018 好未来版权所有', '北京学而思教育科技有限公司', '京ICP备09032638号-16'],
      backSeconds: 300,
      currentType: 0
    }
  },
  methods: {
    goPath (path) {
      console.log('gopath', path)
      this.$router.push(path)
    },
    toggleNav (type) {
      this.currentType = this.currentType === type ? 0 : type
    },
    goDetial () {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802022239')
    },
    goBeian () {
      window.open('https://beian.miit.gov.cn')
    }
  }
}
</script>
<style scoped lang='scss'>
#footerPage {
    position: relative;
    padding-bottom: rem(86);
    background: #0C2444;
    .footer-top{
        width: 100%;
        height: rem(330);
        position: relative;
        background: url('https://haoweilai-tob-video.oss-cn-beijing.aliyuncs.com/img/website/footer-top-m.png') no-repeat center center;
        background-size: 100% 100%;
        .footer-top-content{
            position: absolute;
            width: 100%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title{
                font-size:rem(48);
                font-weight:800;
                color:rgba(255,255,255,1);
            }
            .cooperBtn{
                width:rem(262);
                height: rem(82);
                border: none;
                outline: none;
                font-size: vm(28);
                font-weight:bold;
                color:#FF6D00;
                background-color: transparent;
                border-radius: rem(41);
                margin-top: rem(51);
                border: rem(2) solid #FF6D00;
            }
        }
    }
    .footer-bottom {
        width: 100%;
        color: #fff;
        background: #0C2444;
        position: relative;
        .footer-bottom-content{
            text-align: left;
            .footer-bottom-nav{
                .nav{
                    display: block;
                    padding: rem(29) 0 0;
                    .nav-item{
                        .nav-name{
                            font-size: rem(26);
                            font-weight: 800;
                            line-height: rem(80);
                            .sub-nav{
                                position: relative;
                                padding-left: rem(40);
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                padding-right: rem(50);
                                .sub-nav-img{
                                    width: rem(11);
                                    height: rem(19);
                                }
                                .isRotate{
                                    transform: rotate(90deg);
                                }
                            }
                            .sub-box{
                                padding-left: rem(68);
                                background: #0A1E38;
                                .sub-nav-item{
                                    font-size: rem(26);
                                    font-weight:400;
                                    line-height: rem(70);
                                }
                            }
                        }
                    }
                }
            }
            .footer-bottom-content-item{
                position: relative;
                display:flex;
                justify-content: flex-start;
                align-items: flex-end;
                padding: rem(29) rem(40);
                .introduce-box{
                    font-size:rem(26);
                    font-weight:500;
                    line-height: rem(43);
                    .info-li{
                        a{
                            text-decoration: none;
                            color: #fff;
                        }
                        .title{
                            display: inline-block;
                            width: rem(123);
                        }
                        .content{
                            display: inline-block;
                            margin-top: rem(17);
                        }
                    }
                }
                .qrcode-box{
                    margin-left: rem(24);
                    position: relative;
                    bottom: rem(9);
                    .qrcodeImg{
                        width: rem(111);
                        height: rem(111);
                        background-size: 100%;
                    }
                }
            }
            .copy-box{
                padding: 0 rem(50) rem(20) rem(40);
                .line {
                    width: 100%;
                    height: rem(3);
                    background: #afafb8;
                    margin-top: rem(20);
                }
                .copyright{
                    font-size:rem(16);
                    font-weight:400;
                    margin-top: rem(20);
                }
                .backup{
                  padding-left: rem(28);
                  background: url('../../assets/images/logo/company-record.png') no-repeat left center;
                  background-size: rem(24) rem(24);
                  font-size:rem(16);
                  font-weight:400;
                }
            }
        }
    }
}
</style>
